/**
 * DensityToggle.jsx — CFI-FLOOR-BEH-003
 *
 * Cycles density: compact → comfortable → spacious.
 * Persisted in userPrefsStore (Zustand). Writes data-density to <html>.
 * Compact: 36px rows. Comfortable: 48px. Spacious: 64px (Bloomberg / Stripe / Linear standard).
 */
import { useUserPrefsStore } from '../stores/userPrefsStore.js';

const DENSITIES = ['compact', 'standard', 'spacious'];
const LABELS    = { compact: 'Compact', standard: 'Comfortable', spacious: 'Spacious' };
const ICONS     = {
  compact:   '▤',  // dense lines
  standard:  '▥',  // medium lines
  spacious:  '▦',  // open lines
};

export function DensityToggle() {
  const { density, setDensity } = useUserPrefsStore();

  function cycleDensity() {
    const idx  = DENSITIES.indexOf(density);
    const next = DENSITIES[(idx + 1) % DENSITIES.length];
    setDensity(next);
  }

  return (
    <button
      className="elyon-topbar-btn elyon-density-toggle"
      onClick={cycleDensity}
      aria-label={`Density: ${LABELS[density] ?? density}. Click to change.`}
      title={`Display density: ${LABELS[density] ?? density}`}
      data-density-current={density}
    >
      <span className="elyon-density-icon" aria-hidden="true">
        {ICONS[density] ?? '▥'}
      </span>
    </button>
  );
}
